import styled from '@emotion/styled';

import { spacing, borderRadius, typography, colors } from '../tokens';

const ACCENT = '#0B29FB';
/** BG do card preenchido — lido do Figma (node 10187-51821). */
const CARD_BG = '#F5F7FF';

export const CardRoot = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.lg};
  width: 100%;
  box-sizing: border-box;
  padding: ${spacing.lg} ${spacing.xl};
  background: ${CARD_BG};
  border: 1px solid ${CARD_BG};
  border-radius: ${borderRadius.lg};

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.sm};
  }
`;

export const ContactInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ContactName = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.extraBold};
  color: #3d3d3d;
  line-height: 1.3;
`;

export const ContactMeta = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.regular};
  color: ${colors.textSecondary};
  line-height: 1.3;
`;

export const ChangeButton = styled('button')`
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.extraBold};
  color: ${ACCENT};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${ACCENT};
    outline-offset: 2px;
    border-radius: ${borderRadius.sm};
  }
`;
